import { useMutation } from '@tanstack/react-query';
import { Button, Flex, Form, Input, Modal, Select, message } from 'antd';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PhoneInputWithCountrySelect from 'react-phone-number-input';
import { useSelector } from 'react-redux';
import LookFindrLogo from '../../../../assets/images/LookfindrLogo';
import Info from '../../../../assets/settings/Info.svg';
import { updateSalon } from '../../../../network/settings';
import queryClient from '../../../../services/react-query/queryClient';
import { queryKeys } from '../../../../services/react-query/queryKeys';
import AuthTitleAndDescription from '../../../auth/AuthTitleAndDescription';
import ResetPasswordForm from '../../../auth/ResetPasswordForm';

const EditSalonData = ({
  close,
  email,
  name,
  phone,
  website,
  salonId,
}: any) => {
  const [secPhone, setSecPhone] = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const currentUser = useSelector((s: any) => s?.user?.data);
  console.log(currentUser);

  const initialValues = {
    name: { ar: name.ar, en: name.en },
    email,
    phone,
    website_url: website,
    password: 12345678, // Default password
  };
  const {
    mutate: UpdateSalon,
    isLoading,
    error: addSalonError,
  } = useMutation(updateSalon, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404
      ) {
        message.error(res?.response?.data?.message);
      } else {
        message.success('Salon updated successfully');
        queryClient.invalidateQueries([queryKeys.listSalon]);
        close(false);
      }
    },
  });
  const onFinish = (values: any) => {
    console.log(values);
    UpdateSalon({ id: salonId, ...values });
  };
  const intl = useIntl();
  const handleClosePassword = () => {
    setModalPassword(false);
  };
  return (
    <>
      <Modal
        width="40%"
        centered
        open={modalPassword}
        onCancel={handleClosePassword}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
        destroyOnClose
      >
        <div className="flex flex-col gap-5">
          <Flex justify="center" align="center">
            <LookFindrLogo onClick={() => {}} />
          </Flex>
          <AuthTitleAndDescription
            titleAndDescription={{
              title: intl.formatMessage({ id: 'reset_password_title' }),
              description: intl.formatMessage({
                id: 'reset_password_description',
              }),
            }}
          />
          <ResetPasswordForm
            userId={currentUser?.user?.id}
            handleClosePassword={handleClosePassword}
          />
        </div>
      </Modal>
      <h5 className="w-full mb-6 text-lg font-semibold ">
        <FormattedMessage id="edit_salon_general_info" />
      </h5>
      <Form
        layout="vertical"
        name="edit-salon"
        onFinish={onFinish}
        className="grid w-full grid-cols-2 gap-4 max-md:grid-cols-1"
        initialValues={initialValues}
      >
        <div className="flex items-center max-lg:flex-col lg:gap-4">
          <Form.Item
            name={['name', 'ar']}
            label={intl.formatMessage({ id: 'salonNameLabelAr' })}
            className="w-full"
            required={false}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: 'salonNameRequiredAr' }), // Make sure to define a message ID for required fields in your internationalization messages
              },
              {
                validator: (_, value) => {
                  if (!/^[ء-ي0-9 ]+$/.test(value)) {
                    // Regular expression for Arabic characters and numbers
                    return Promise.reject(
                      new Error(
                        intl.formatMessage({
                          id: `localization.Only[ar]`, // Adjust the localization key as necessary
                        })
                      )
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input className="text-sm font-semibold text-color-primary" />
          </Form.Item>
          <Form.Item
            name={['name', 'en']}
            label={intl.formatMessage({ id: 'salonNameLabelEn' })}
            className="w-full"
            required={false}
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: 'salonNameRequiredEn' }), // Similarly, define a message for the English input field
              },
              {
                validator: (_, value) => {
                  if (!/^[A-Za-z0-9 ]+$/.test(value)) {
                    // Regular expression for English characters and numbers
                    return Promise.reject(
                      new Error(
                        intl.formatMessage({
                          id: `localization.Only[en]`, // Adjust the localization key as necessary
                        })
                      )
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input className="text-sm font-semibold text-color-primary" />
          </Form.Item>
        </div>

        <div>
          <div className="flex items-center w-full gap-2 max-lg:flex-col">
            <Form.Item
              label={
                <div className="text-sm">
                  {intl.formatMessage({ id: 'mainSalonPhoneNumberLabel' })}
                </div>
              }
              name="phone"
              required={false}
              className="w-full"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: 'phoneRequired',
                    defaultMessage: 'يجب إدخال رقم جوال ',
                  }),
                },
              ]}
            >
              <PhoneInputWithCountrySelect
                defaultCountry="SA"
                // value={value1}
                // onChange={setValue1}
                onChange={() => {}}
                international
                limitMaxLength={true}
                className="!border-[1px] !border-solid !border-color-primary !py-2 !px-[11px] !h-[42px]"
              />
            </Form.Item>
            {/* <Button
              type="default"
              className={`flex items-center justify-center gap-2 max-lg:mt-6 w-full ${
                secPhone && "hidden"
              }`}
              onClick={() => setSecPhone((e: any) => !e)}
            >
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.4141 2.3999H4.78906C4.20911 2.4006 3.65312 2.63129 3.24303 3.04137C2.83295 3.45146 2.60226 4.00745 2.60156 4.5874L2.60156 14.2124C2.60226 14.7923 2.83295 15.3483 3.24303 15.7584C3.65312 16.1685 4.20911 16.3992 4.78906 16.3999H14.4141C14.994 16.3992 15.55 16.1685 15.9601 15.7584C16.3702 15.3483 16.6009 14.7923 16.6016 14.2124V4.5874C16.6009 4.00745 16.3702 3.45146 15.9601 3.04137C15.55 2.63129 14.994 2.4006 14.4141 2.3999ZM15.7266 14.2124C15.7266 14.5605 15.5883 14.8943 15.3421 15.1405C15.096 15.3866 14.7622 15.5249 14.4141 15.5249H4.78906C4.44097 15.5249 4.10713 15.3866 3.86098 15.1405C3.61484 14.8943 3.47656 14.5605 3.47656 14.2124V4.5874C3.47656 4.23931 3.61484 3.90547 3.86098 3.65932C4.10713 3.41318 4.44097 3.2749 4.78906 3.2749H14.4141C14.7622 3.2749 15.096 3.41318 15.3421 3.65932C15.5883 3.90547 15.7266 4.23931 15.7266 4.5874V14.2124Z"
                  fill="#00086D"
                />
                <path
                  d="M9.89766 6.63037H9.29766V9.33037H6.59766V9.93037H9.29766V12.6304H9.89766V9.93037H12.5977V9.33037H9.89766V6.63037Z"
                  fill="#00086D"
                />
              </svg>
              {intl.formatMessage({ id: "additionalPhoneNumberButton" })}
            </Button> */}
          </div>
          {secPhone && (
            <Form.Item
              name="secondaryPhoneNumber"
              required={false}
              className=""
            >
              <PhoneInputWithCountrySelect
                defaultCountry="SA"
                onChange={() => {}}
                international
                limitMaxLength={true}
                className="!border-[1px] w-[100%] !border-solid !border-color-primary mt-9 !py-2 !px-[11px] !h-[42px]"
              />
            </Form.Item>
          )}
        </div>
        <div className="relative">
          <Form.Item
            name={'password'}
            label={intl.formatMessage({ id: 'Password1' })}
            colon={false}
            required={false}
            hasFeedback
          >
            <Input.Password
              disabled
              className="" // Padding to prevent text from overlapping the suffix
              iconRender={() => null}
            />
          </Form.Item>
          {/* <div
            onClick={() => setModalPassword(true)}
            className="absolute cursor-pointer z-50 h-[35px] text-sm rounded-lg bottom-1/3 translate-y-[3%] left-1 flex items-center px-[8px] py-[0px] bg-[#EEF0FF] text-color-primary w-fit"
          >
            {intl.formatMessage({ id: "change_password" })}
          </div> */}
        </div>
        <Form.Item
          name="email"
          label={intl.formatMessage({ id: 'emailLabel' })}
          rules={[{ type: 'email' }]}
        >
          <Input className="text-sm font-semibold text-color-primary" />
        </Form.Item>
        <Form.Item
          name="website_url"
          rules={[
            {
              type: 'url',
              message: 'الرجاء إدخال عنوان موقع إلكتروني صحيح',
            },
          ]}
          label={
            <Flex>
              <span className="mx-1">
                {intl.formatMessage({ id: 'websiteLabel' })}
              </span>
              <small className="text-xs self-center mt-2 text-[#75757E]">
                (
                {intl.formatMessage({
                  id: 'optional',
                  defaultMessage: 'اختياري',
                })}
                )
              </small>
            </Flex>
          }
        >
          <Input className="text-sm font-semibold text-color-primary" />
        </Form.Item>
        <Form.Item
          name="lang"
          label={intl.formatMessage({ id: 'platformLanguageLabel' })}
        >
          <Select
            defaultValue="arabic"
            options={[
              { value: 'ar', label: 'arabic' },
              { value: 'en', label: 'english' },
            ]}
          />
        </Form.Item>
        <div className="flex items-center gap-4">
          <img src={Info} className="w-6 h-6" alt="" />
          <span className="flex text-sm text-[#9999A7] items-center">
            {intl.formatMessage({ id: 'teamMembersInfo' })}
          </span>
        </div>
        <Form.Item className="w-full md:col-span-2 justify-self-end md:w-1/4">
          <div className="flex items-center w-full gap-2">
            <Button className="w-full " type="primary" htmlType="submit">
              {intl.formatMessage({ id: 'saveChangesButton' })}
            </Button>
            <Button
              onClick={() => close(false)}
              className="w-full btn-primary-not"
              type="primary"
            >
              {intl.formatMessage({ id: 'cancelButton' })}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default EditSalonData;
